import React, { useState, useEffect } from 'react';
import { Edit, Trash2, Save, X, Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import ImageUploader from '../../components/admin/ImageUploader';
import axios from 'axios';

const RentalsManager = () => {
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchRentals();
  }, []);

  const fetchRentals = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/rentals`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRentals(response.data.rentals);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const startCreating = () => {
    setIsCreating(true);
    setEditing(null);
    setFormData({
      title: '',
      title_en: '',
      description: '',
      description_en: '',
      price: '',
      image: '/api/uploads/balloon1.jpg'
    });
  };

  const handleCreate = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/rentals`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setIsCreating(false);
      setFormData({});
      fetchRentals();
      alert('Équipement ajouté avec succès!');
    } catch (error) {
      alert('Erreur lors de la création');
    }
  };

  const handleSave = async () => {
    if (isCreating) {
      await handleCreate();
      return;
    }
    
    try {
      const token = localStorage.getItem('admin_token');
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/rentals/${editing}`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEditing(null);
      fetchRentals();
    } catch (error) {
      alert('Erreur');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    try {
      const token = localStorage.getItem('admin_token');
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/rentals/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchRentals();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div></div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Location d'Équipement</h1>
          <p className="text-gray-600 mt-1">Gérez vos équipements de location</p>
        </div>
        <Button onClick={startCreating} className="bg-purple-600 hover:bg-purple-700">
          <Plus className="w-4 h-4 mr-2" />
          Ajouter un Équipement
        </Button>
      </div>

      {isCreating && (
        <Card className="border-2 border-purple-500">
          <CardContent className="pt-6 space-y-4">
            <div className="flex items-center gap-2 mb-4">
              <Plus className="w-5 h-5 text-purple-600" />
              <h3 className="font-bold text-lg">Nouvel Équipement</h3>
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div><Label>Titre (FR)</Label><Input value={formData.title || ''} onChange={(e) => setFormData({ ...formData, title: e.target.value })} /></div>
              <div><Label>Title (EN)</Label><Input value={formData.title_en || ''} onChange={(e) => setFormData({ ...formData, title_en: e.target.value })} /></div>
              <div><Label>Description (FR)</Label><Input value={formData.description || ''} onChange={(e) => setFormData({ ...formData, description: e.target.value })} /></div>
              <div><Label>Description (EN)</Label><Input value={formData.description_en || ''} onChange={(e) => setFormData({ ...formData, description_en: e.target.value })} /></div>
              <div><Label>Prix (ex: 75$)</Label><Input value={formData.price || ''} onChange={(e) => setFormData({ ...formData, price: e.target.value })} /></div>
              <div>
                <ImageUploader
                  value={formData.image || ''}
                  onChange={(url) => setFormData({ ...formData, image: url })}
                  label="Image de l'Équipement"
                />
              </div>
            </div>
            <div className="flex gap-2">
              <Button onClick={handleSave} className="bg-green-600"><Save className="w-4 h-4 mr-2" />Créer</Button>
              <Button onClick={() => { setIsCreating(false); setFormData({}); }} variant="outline">Annuler</Button>
            </div>
          </CardContent>
        </Card>
      )}

      <div className="grid gap-4">
        {rentals.map((rental) => (
          <Card key={rental.id}>
            {editing === rental.id ? (
              <CardContent className="pt-6 space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div><Label>Titre (FR)</Label><Input value={formData.title || ''} onChange={(e) => setFormData({ ...formData, title: e.target.value })} /></div>
                  <div><Label>Title (EN)</Label><Input value={formData.title_en || ''} onChange={(e) => setFormData({ ...formData, title_en: e.target.value })} /></div>
                  <div><Label>Description (FR)</Label><Input value={formData.description || ''} onChange={(e) => setFormData({ ...formData, description: e.target.value })} /></div>
                  <div><Label>Description (EN)</Label><Input value={formData.description_en || ''} onChange={(e) => setFormData({ ...formData, description_en: e.target.value })} /></div>
                  <div><Label>Prix (ex: 75$)</Label><Input value={formData.price || ''} onChange={(e) => setFormData({ ...formData, price: e.target.value })} /></div>
                  <div>
                    <ImageUploader
                      value={formData.image || ''}
                      onChange={(url) => setFormData({ ...formData, image: url })}
                      label="Image de l'Équipement"
                    />
                  </div>
                </div>
                <div className="flex gap-2">
                  <Button onClick={handleSave} className="bg-green-600"><Save className="w-4 h-4 mr-2" />Sauvegarder</Button>
                  <Button onClick={() => { setEditing(null); setFormData({}); }} variant="outline">Annuler</Button>
                </div>
              </CardContent>
            ) : (
              <div className="flex items-center gap-4 p-6">
                <img src={rental.image.startsWith('http') ? rental.image : `${process.env.REACT_APP_BACKEND_URL}${rental.image}`} alt={rental.title} className="w-20 h-20 object-cover rounded-lg" />
                <div className="flex-1"><h3 className="font-bold">{rental.title}</h3><p className="text-sm text-gray-600">{rental.description}</p><p className="text-purple-600 font-semibold mt-1">{rental.price}</p></div>
                <div className="flex gap-2">
                  <Button size="sm" onClick={() => { setEditing(rental.id); setFormData(rental); }}><Edit className="w-4 h-4" /></Button>
                  <Button size="sm" variant="destructive" onClick={() => handleDelete(rental.id)}><Trash2 className="w-4 h-4" /></Button>
                </div>
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RentalsManager;
